import { useEffect as o } from "react";
import { enUS as t } from "../../../node_modules/date-fns/locale/en-US.mjs";
import { LanguageCodeEnum as r } from "../../../libs/types/dist/index12.mjs";
const k = (i, e) => {
  o(() => {
    (async () => {
      try {
        if (i) {
          let a;
          switch (i) {
            case r.ENGLISH:
              a = t;
              break;
            case r.CHINESE:
              a = (await import("../../../node_modules/date-fns/locale/zh-CN.mjs")).zhCN;
              break;
            case r.ARABIC:
              a = (await import("../../../node_modules/date-fns/locale/ar.mjs")).ar;
              break;
            case r.CZECH:
              a = (await import("../../../node_modules/date-fns/locale/cs.mjs")).cs;
              break;
            case r.DANISH:
              a = (await import("../../../node_modules/date-fns/locale/da.mjs")).da;
              break;
            case r.DEUTSCH:
              a = (await import("../../../node_modules/date-fns/locale/de.mjs")).de;
              break;
            case r.GREEK:
              a = (await import("../../../node_modules/date-fns/locale/el.mjs")).el;
              break;
            case r.SPANISH:
              a = (await import("../../../node_modules/date-fns/locale/es.mjs")).es;
              break;
            case r.FRENCH:
              a = (await import("../../../node_modules/date-fns/locale/fr.mjs")).fr;
              break;
            case r.HINDI:
              a = (await import("../../../node_modules/date-fns/locale/hi.mjs")).hi;
              break;
            case r.HUNGARIAN:
              a = (await import("../../../node_modules/date-fns/locale/hu.mjs")).hu;
              break;
            case r.INDONESIAN:
              a = (await import("../../../node_modules/date-fns/locale/id.mjs")).id;
              break;
            case r.ITALIAN:
              a = (await import("../../../node_modules/date-fns/locale/it.mjs")).it;
              break;
            case r.JAPANESE:
              a = (await import("../../../node_modules/date-fns/locale/ja.mjs")).ja;
              break;
            case r.NORWEGIAN:
              a = (await import("../../../node_modules/date-fns/locale/nb.mjs")).nb;
              break;
            case r.DUTCH:
              a = (await import("../../../node_modules/date-fns/locale/nl.mjs")).nl;
              break;
            case r.POLISH:
              a = (await import("../../../node_modules/date-fns/locale/pl.mjs")).pl;
              break;
            case r.PORTUGUESE:
              a = (await import("../../../node_modules/date-fns/locale/pt.mjs")).pt;
              break;
            case r.ROMANIAN:
              a = (await import("../../../node_modules/date-fns/locale/ro.mjs")).ro;
              break;
            case r.RUSSIAN:
              a = (await import("../../../node_modules/date-fns/locale/ru.mjs")).ru;
              break;
            case r.SLOVAK:
              a = (await import("../../../node_modules/date-fns/locale/sk.mjs")).sk;
              break;
            case r.SLOVENIAN:
              a = (await import("../../../node_modules/date-fns/locale/sl.mjs")).sl;
              break;
            case r.ALBANIA:
              a = (await import("../../../node_modules/date-fns/locale/sq.mjs")).sq;
              break;
            case r.SERBIAN:
              a = (await import("../../../node_modules/date-fns/locale/sr.mjs")).sr;
              break;
            case r.SWEDISH:
              a = (await import("../../../node_modules/date-fns/locale/sv.mjs")).sv;
              break;
            case r.THAI:
              a = (await import("../../../node_modules/date-fns/locale/th.mjs")).th;
              break;
            case r.TURKISH:
              a = (await import("../../../node_modules/date-fns/locale/tr.mjs")).tr;
              break;
            case r.UKRAINIAN:
              a = (await import("../../../node_modules/date-fns/locale/uk.mjs")).uk;
              break;
            default:
              a = t;
              break;
          }
          e(a);
        } else
          e(t);
      } catch (a) {
        console.error("Error loading locale:", a), e(t);
      }
    })();
  }, [i, e]);
};
export {
  k as useDateFnsLocale
};
